import { AudioContext } from 'standardized-audio-context';
import { EventTarget } from '@web-media/event-target';
import { OpenPromise, OpenPromiseState } from '@web-media/open-promise';

class MediaDeMuxAdapter {
  

  




}

var ParsingBehavior; (function (ParsingBehavior) {
  const WaitForMoreData = 0; ParsingBehavior[ParsingBehavior["WaitForMoreData"] = WaitForMoreData] = "WaitForMoreData";
})(ParsingBehavior || (ParsingBehavior = {}));

function _nullishCoalesce$3(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }





















const mpegVersionLookup = {
  0: 2,
  1: 1,
};

const mpegLayerLookup = {
  1: 3,
  2: 2,
  3: 1,
};

const sampleRateLookup = {
  0: 44100,
  1: 48000,
  2: 32000,
};

const channelModeLookup = {
  0: 'stereo',
  1: 'joint stereo',
  2: 'dual channel',
  3: 'mono',
};

// You should see [73, 68, 51, 4, 0, 0, 0, 0, 0, 0] in your debugger.
const id3Header = new Uint8Array([
  0x49, 0x44, 0x33, 0x04, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,
]);

// http://mpgedit.org/mpgedit/mpeg_format/mpeghdr.htm
const bitrateLookup = {
  11: [null, 32, 64, 96, 128, 160, 192, 224, 256, 288, 320, 352, 384, 416, 448],
  12: [null, 32, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, 384],
  13: [null, 32, 40, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320],
  21: [null, 32, 48, 56, 64, 80, 96, 112, 128, 144, 160, 176, 192, 224, 256],
  22: [null, 8, 16, 24, 32, 40, 48, 56, 64, 80, 96, 112, 128, 144, 160],
};

// eslint-disable-next-line prefer-destructuring
bitrateLookup[23] = bitrateLookup[22];

const CHUNK_SIZE = 64 * 1024;

class Mp3DeMuxAdapter extends MediaDeMuxAdapter


 {constructor(...args) { super(...args); Mp3DeMuxAdapter.prototype.__init.call(this);Mp3DeMuxAdapter.prototype.__init2.call(this); }
  __init() {this.metadata = undefined;}

  // eslint-disable-next-line class-methods-use-this
  __init2() {this.appendData = (
    value,
    _loadBatchId,
    loadStreamFinalized,
  ) => {
    let lastHeaderPosition = null;
    const frameMetadataSequence = [];

    if (
      value.length < CHUNK_SIZE + 4 &&
      !loadStreamFinalized
    ) return ParsingBehavior.WaitForMoreData;

    let headerPosition = 0; // isFirstChunk ? 32 :
    while (headerPosition < value.length) {
      const headerValidate = Mp3DeMuxAdapter.validateHeader(value, headerPosition);

      if (!headerValidate) {
        headerPosition += 1;
        continue;
      }

      const frameFrameHeader = Mp3DeMuxAdapter.processFrameHeader(value, headerPosition);
      const frameMetadata = Mp3DeMuxAdapter.parseMetadata(frameFrameHeader);

      if (
        lastHeaderPosition !== null &&
        headerPosition - lastHeaderPosition <= 4
      ) {
        headerPosition += 1;
        continue;
      }

      const frameLength = Mp3DeMuxAdapter.getFrameLength(
        value,
        headerPosition,
        frameMetadata
      );

      if (!frameLength) {
        headerPosition += 1;
        continue;
      }

      const end = headerPosition + frameLength;

      if (end > value.length) break;

      frameMetadataSequence.push({
        ...frameMetadata,
        start: headerPosition,
        end,
      });

      lastHeaderPosition = headerPosition;

      headerPosition = end - Math.min(frameLength, 4) + 1;

      if (headerPosition > CHUNK_SIZE) break;
    }

    if (frameMetadataSequence.length < 4 && !loadStreamFinalized) {
      return ParsingBehavior.WaitForMoreData;
    }

    const { start } = frameMetadataSequence[0];
    let { end } = frameMetadataSequence[frameMetadataSequence.length - 1];

    if (loadStreamFinalized) {
      end = value.length;
    }

    const rawChunkData = value.slice(start, end);

    const newChunk = {
      rawData: rawChunkData,
      metadata: frameMetadataSequence,
      duration: frameMetadataSequence.reduce(
        (a, x) => 1152 / x.sampleRate + a,
        0
      ),
      frames: frameMetadataSequence.length,
      get wrappedData() {
        return Mp3DeMuxAdapter.wrapChunk(this.rawData);
      },
    };

    return {
      skipped: start,
      consumed: start + rawChunkData.length,
      data: newChunk,
    };
  };}

  static __initStatic() {this.validateHeader = (data, i = 0) => {
    // First 11 bits should be set to 1, and the 12nd bit should be 1 if the audio is MPEG Version 1 or
    // MPEG Version 2, this means MPEG Version 2.5 is not supported by this library.
    if (data[i + 0] !== 0b11111111 || (data[i + 1] & 0b11110000) !== 0b11110000)
      return false;

    const valid =
      // Layer Description should not be 00, since it is reserved
      (data[i + 1] & 0b00000110) !== 0b00000000 &&
      // Bitrate should not be 1111, since it is bad
      (data[i + 2] & 0b11110000) !== 0b11110000 &&
      // Sampling Rate Frequency should not be 11, the value is reserved
      (data[i + 2] & 0b00001100) !== 0b00001100 &&
      // Emphasis should not be 10, the value is reserved
      (data[i + 3] & 0b00000011) !== 0b00000010;

    return valid;
  };}

  static __initStatic2() {this.processFrameHeader = (data, i = 0) => {
    if (data[i + 0] !== 0b11111111 || (data[i + 1] & 0b11110000) !== 0b11110000)
      throw new TypeError(`Invalid frame header!`);

    return {
      type: 'raw',
      mpegVersion: data[i + 1] & 0b00001000,
      mpegLayer: data[i + 1] & 0b00000110,
      sampleRate: data[i + 2] & 0b00001100,
      channelMode: data[i + 3] & 0b11000000,
    } 
  };}

  static __initStatic3() {this.parseMetadata = (metadata) => {
    const mpegVersion = mpegVersionLookup[metadata.mpegVersion >> 3];

    return {
      type: 'parsed',
      mpegVersion,
      mpegLayer: mpegLayerLookup[metadata.mpegLayer >> 1],
      sampleRate: sampleRateLookup[metadata.sampleRate >> 2] / mpegVersion,
      channelMode: channelModeLookup[metadata.channelMode >> 6],
    };
  };}

  static __initStatic4() {this.wrapChunk = (original) => {
    if (original.length >= 3) {
      if (
        original[0] === 0x49 &&
        original[1] === 0x44 &&
        original[2] === 0x33
      ) {
        // already has ID3 header
        return original;
      }
    }

    const result = new Uint8Array(id3Header.length + original.length);

    for (let i = 0; i < id3Header.length; i += 1) {
      result[i] = id3Header[i];
    }

    for (let i = 0; i < original.length; i += 1) {
      result[i + id3Header.length] = original[i];
    }

    return result;
  };}

  /**
   * Frame length is length of a frame when compressed. It is calculated in
   * slots. One slot is 4 bytes long for Layer I, and one byte long for Layer II
   * and Layer III.
   */
  static __initStatic5() {this.getFrameLength = (
    data,
    i,
    metadata
  ) => {
    const { mpegVersion, mpegLayer, sampleRate } = metadata;

    const bitrateCode = (data[i + 2] & 0b11110000) >> 4;

    const bitrateBase = _nullishCoalesce$3(bitrateLookup[`${mpegVersion}${mpegLayer}`][bitrateCode], () => ( 0));

    const bitrate = bitrateBase * 1e3;
    const padding = (data[i + 2] & 0b00000010) >> 1;

    const length = ~~(mpegLayer === 1
      ? ((12 * bitrate) / sampleRate + padding) * 4
      : (144 * bitrate) / sampleRate + padding);

    return length;
  };}
} Mp3DeMuxAdapter.__initStatic(); Mp3DeMuxAdapter.__initStatic2(); Mp3DeMuxAdapter.__initStatic3(); Mp3DeMuxAdapter.__initStatic4(); Mp3DeMuxAdapter.__initStatic5();

function _nullishCoalesce$2(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }
class ErrorEvent extends CustomEvent {
  constructor( error) {
    super('error', { detail: error });this.error = error;  }
}

class Chunk extends EventTarget {
  

  

  __init() {this.duration = null;}

  

  

  

   __init2() {this.decoded = new OpenPromise();}

   __init3() {this.attached = new OpenPromise();}

  __init4() {this.next = null;}

  

  constructor({
    clip,
    chunk,
    adapter,
    chunkIndex,
  }




) {
    super();Chunk.prototype.__init.call(this);Chunk.prototype.__init2.call(this);Chunk.prototype.__init3.call(this);Chunk.prototype.__init4.call(this);    this.clip = clip;
    this.chunkIndex = chunkIndex;
    this.context = clip.context;

    this.chunk = chunk;
    this.extended = null;

    this.adapter = adapter;

    this.duration = null;

    const { wrappedData } = chunk;

    this.context
      .decodeAudioData(wrappedData.buffer)
      .then(() => {
        this.duration = this.chunk.duration;
        this.decoded.resolve(null);
      })
      .catch((error) => {
        this.decoded.reject(error);
        const warpedError = _nullishCoalesce$2(error, () => ( new Error(`Could not decode audio buffer`)));

        this.dispatchEvent(new ErrorEvent(warpedError));
        this.attached.reject(warpedError);
      });
  }

  async attach(nextChunk) {
    if (nextChunk === this) {
      throw new Error(`Loop chain detected`);
    }

    if (this.attached.state !== OpenPromiseState.Idle) {
      throw new Error(`Chunk alreay attached`);
    }

    this.next = nextChunk;

    await this.resolveAttachedState();
  }

  createBuffer() {
    if (!this.attached) {
      throw new Error(
        'Something went wrong! Chunk was not ready in time for playback'
      );
    }

    return this.context.decodeAudioData(this.extended.slice(0).buffer);
  }

   async resolveAttachedState() {
    this.attached.resolve(true);

    await this.decoded;

    if (this.duration === null) {
      throw new Error('Edge case detected, duration is null');
    }

    const thisChunkData = this.chunk.wrappedData;

    if (this.next) {
      const nextChunkData = this.next.chunk.rawData;

      const thisLength = thisChunkData.length;
      // we don't need the whole thing
      const nextLength = nextChunkData.length >> 1;

      this.extended = new Uint8Array(thisLength + nextLength);

      let p = 0;

      for (let i = 0; i < thisLength; i += 1, p += 1) {
        this.extended[p] = thisChunkData[i];
      }

      for (let i = 0; i < nextLength; i += 1, p += 1) {
        this.extended[p] = nextChunkData[i];
      }
    } else {
      this.extended = thisChunkData;
    }
  }
}

function _nullishCoalesce$1(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain$1(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }class AudioFetcherError extends Error { }

class BinaryLoader {
  constructor(
      url,
      abortSignal
  ) {this.url = url;this.abortSignal = abortSignal;BinaryLoader.prototype.__init.call(this);BinaryLoader.prototype.__init2.call(this);BinaryLoader.prototype.__init3.call(this);BinaryLoader.prototype.__init4.call(this);BinaryLoader.prototype.__init5.call(this);BinaryLoader.prototype.__init6.call(this); }

   __init() {this.fetched = false;}

   __init2() {this.totalSize = 0;}

   __init3() {this.downloadedSize = 0;}

   __init4() {this.progress = 0;}

   __init5() {this.buffer = null;}

  __init6() {this.consume = (size) => {
    this.buffer = _nullishCoalesce$1(_optionalChain$1([this, 'access', _4 => _4.buffer, 'optionalAccess', _5 => _5.slice, 'call', _6 => _6(size)]), () => ( null));

    return this.buffer;
  };}

  async *fetch() {
    if (this.fetched) {
      throw new AudioFetcherError(`The file is already fetched`);
    }

    this.fetched = true;

    const request = await fetch(this.url, { signal: this.abortSignal });
    this.totalSize =
      _nullishCoalesce$1(Number.parseFloat(_nullishCoalesce$1(request.headers.get('content-length'), () => ( '0'))), () => ( 0));

    if (!request.ok) {
      throw new AudioFetcherError(
        `Failed to request the file, ${request.status}(${request.statusText})`
      );
    }

    const reader = _optionalChain$1([request, 'access', _7 => _7.body, 'optionalAccess', _8 => _8.getReader, 'call', _9 => _9()]);

    if (!reader) {
      throw new TypeError(`Valid reader not found`);
    }

    let done = false;

    while (!done) {
      if (_optionalChain$1([this, 'access', _10 => _10.abortSignal, 'optionalAccess', _11 => _11.aborted])) return;

      const { value, done: d } = await reader.read();
      done = d;

      if (value) {
        this.downloadedSize += value.byteLength;
        this.progress = this.downloadedSize / this.totalSize;
      }

      if (!this.buffer && value) {
        this.buffer = value;
      } else if (this.buffer && value) {
        const nextBuffer = new Uint8Array(
          this.buffer.length + value.length
        );

        nextBuffer.set(this.buffer);
        nextBuffer.set(value, this.buffer.length);

        this.buffer = nextBuffer;
      }

      yield this.buffer;
    }
  }
}

class LoadEvent extends CustomEvent {
  constructor() {
    super('load');
  }
}

class PauseEvent extends CustomEvent {
  constructor() {
    super('pause');
  }
}

class EndedEvent extends CustomEvent {
  constructor() {
    super('ended');
  }
}

class DisposeEvent extends CustomEvent {
  constructor() {
    super('dispose');
  }
}

class LoadErrorEvent extends CustomEvent {
  constructor(
    url,
    phonographCode,
    error,
     cause
  ) {
    super('loaderror', { detail: { url, phonographCode, error } });this.cause = cause;  }
}

class LoadProgressEvent extends CustomEvent {
  constructor(progress, loaded, total) {
    super('loadprogress', {
      detail: { progress, loaded, total },
    });
  }
}

class PlaybackErrorEvent extends CustomEvent {
  constructor(error) {
    super('playbackerror', { detail: error });
  }
}

class CanPlayThroughEvent extends CustomEvent {
  constructor() {
    super('canplaythrough');
  }
}

class PhonographClipError extends Error {
  

  

  constructor(message, opts) {
    super(message);

    this.phonographCode = opts.phonographCode;
    this.url = opts.url;
  }
}

function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }/* eslint-disable no-restricted-syntax */

const OVERLAP = 0.2;

// A cache of audio buffers starting from current time









class Clip extends EventTarget {
  

  

  

  

  __init() {this.buffered = 0;}

  __init2() {this.length = 0;}

  __init3() {this.loaded = new OpenPromise();}

  __init4() {this.canPlayThough = new OpenPromise();}

  __init5() {this.controller = new AbortController();}

  

  __init6() {this.playing = false;}

  __init7() {this.ended = false;}

   __init8() {this._startTime = 0;}

   __init9() {this._currentTime = 0;}

   __init10() {this._chunks = [];}

   __init11() {this._contextTimeAtStart = 0;}

   __init12() {this._pendingSourceStart = 0;}

   __init13() {this._connected = false;}

  

  

   __init14() {this._loadStarted = false;}

   __init15() {this._actualPlaying = false;}

   get stuck() {
    if (this.playing) {
      return !this._actualPlaying;
    }
    return !this.audioBufferCacheHit();
  }

   __init16() {this._currentSource = null;}

   __init17() {this._nextSource = null;}

   __init18() {this._currentGain = null;}

   __init19() {this._nextGain = null;}

   __init20() {this._audioBufferCache


 = null;}

  constructor({
    context,
    url,
    loop,
    volume,
    adapter,
  }





) {
    super();Clip.prototype.__init.call(this);Clip.prototype.__init2.call(this);Clip.prototype.__init3.call(this);Clip.prototype.__init4.call(this);Clip.prototype.__init5.call(this);Clip.prototype.__init6.call(this);Clip.prototype.__init7.call(this);Clip.prototype.__init8.call(this);Clip.prototype.__init9.call(this);Clip.prototype.__init10.call(this);Clip.prototype.__init11.call(this);Clip.prototype.__init12.call(this);Clip.prototype.__init13.call(this);Clip.prototype.__init14.call(this);Clip.prototype.__init15.call(this);Clip.prototype.__init16.call(this);Clip.prototype.__init17.call(this);Clip.prototype.__init18.call(this);Clip.prototype.__init19.call(this);Clip.prototype.__init20.call(this);Clip.prototype.__init21.call(this);Clip.prototype.__init22.call(this);Clip.prototype.__init23.call(this);Clip.prototype.__init24.call(this);
    this.context = context || new AudioContext();
    this.url = url;
    this.loop = loop || false;
    this.adapter = adapter;

    this.loader = new BinaryLoader(url, this.controller.signal);

    this.fadeTarget = volume || 1;
    this._gain = this.context.createGain();
    this._gain.gain.value = this.fadeTarget;

    this._gain.connect(this.context.destination);

    this._chunks = [];

    this.canPlayThough.then(() => {
      this.dispatchEvent(new CanPlayThroughEvent());
    });
  }

  /**
   * calculates if enough audio data is available to start playing and finish
   * downloading before running out.
   * If the conditions inside the function are met, it will resolve the
   * `canPlayThough` promise to `true`. Otherwise, it may not perform any
   * action.
   */
   __init21() {this.checkCanPlayThrough = (
    loadStartTime,
    totalLoadedBytes
  ) => {
    if (this.canPlayThough.state !== OpenPromiseState.Fulfilled || !this.length)
      return;
    let duration = 0;
    let bytes = 0;
    for (const chunk of this._chunks) {
      if (!chunk.duration) break;
      duration += chunk.duration;
      bytes += chunk.chunk.rawData.length;
    }
    if (!duration) return;
    const scale = this.length / bytes;
    const estimatedDuration = duration * scale;
    const timeNow = Date.now();
    const elapsed = timeNow - loadStartTime;
    const bitrate = totalLoadedBytes / elapsed;
    const estimatedTimeToDownload =
      (1.5 * (this.length - totalLoadedBytes)) / bitrate / 1e3;
    // if we have enough audio that we can start playing now
    // and finish downloading before we run out, we've
    // reached can play through
    const availableAudio = (bytes / this.length) * estimatedDuration;
    if (availableAudio > estimatedTimeToDownload) {
      if (this.canPlayThough.state !== OpenPromiseState.Fulfilled) {
        this.canPlayThough.resolve(true);
      }
    }
  };}

   __init22() {this.handleChunkReady = (loadStartTime, totalLoadedBytes) => {
    this.checkCanPlayThrough(loadStartTime, totalLoadedBytes);
  };}

   __init23() {this.handleChunkError = (({ detail, target }) => {
    const loadErrorEvent = new LoadErrorEvent(
      this.url,
      'COULD_NOT_DECODE',
      detail,
      target
    );

    this.dispatchEvent(loadErrorEvent);
  }); }

  /**
   * Asynchronously loads and processes audio data, checking for readiness to
   * play through and handling errors accordingly.
   */
  async buffer() {
    this._loadStarted = true;
    const loadStartTime = Date.now();
    let totalLoadedBytes = 0;

    try {
      const { loader } = this;
      const fetcher = loader.fetch();
      let done = false;
      let batchId = 0;

      while (!done || _optionalChain([loader, 'access', _ => _.buffer, 'optionalAccess', _2 => _2.length]) !== 0) {
        this.controller.signal.throwIfAborted();
        const { done: d } = await fetcher.next();
        done = !!d;

        this.buffered = this.loader.downloadedSize;
        this.length = this.loader.totalSize;
        this.dispatchEvent(
          new LoadProgressEvent(
            this.loader.progress,
            this.loader.downloadedSize,
            this.loader.totalSize
          )
        );

        while (_optionalChain([loader, 'access', _3 => _3.buffer, 'optionalAccess', _4 => _4.length])) {
          const parseResult = this.adapter.appendData(
            loader.buffer,
            batchId,
            done
          );
          batchId += 1;

          if (parseResult === ParsingBehavior.WaitForMoreData) break;

          const { consumed, data } = parseResult;

          this.loader.consume(consumed);

          const chunk = new Chunk({
            clip: this,
            chunkIndex: this._chunks.length,
            chunk: data,
            adapter: this.adapter,
          });

          chunk.on('error', this.handleChunkError);

          await chunk.decoded;

          this.handleChunkReady(loadStartTime, totalLoadedBytes);

          // Connect last chunk with this chunk to create a chunk chain.
          const lastChunk = this._chunks[this._chunks.length - 1];
          if (lastChunk) await lastChunk.attach(chunk);

          this._chunks.push(chunk);
          totalLoadedBytes += consumed;
        }
      }

      const firstChunk = this._chunks[0];

      if (!firstChunk) {
        throw new TypeError(
          `No first chunk found, this is not a valid MP3 file`
        );
      }

      // Last chunk should be resolved manually.
      const lastChunk = this._chunks[this._chunks.length - 1];
      await lastChunk.attach(null);

      await firstChunk.decoded;

      await this.trySetupAudioBufferCache();

      if (this.canPlayThough.state !== OpenPromiseState.Fulfilled) {
        this.canPlayThough.resolve(true);
      }
      this.loaded.resolve(true);
      this.dispatchEvent(new LoadEvent());
    } catch (error) {
      const newEvent = new LoadErrorEvent(this.url, 'COULD_NOT_DECODE', error);
      this.dispatchEvent(newEvent);
      this._loadStarted = false;

      throw error;
    }
  }

  connect(
    destination,
    output,
    input
  ) {
    if (!this._connected) {
      this._gain.disconnect();
      this._connected = true;
    }

    this._gain.connect(destination, output, input);
    return this;
  }

  disconnect(
    destination,
    output,
    input
  ) {
    this._gain.disconnect(destination, output, input);
  }

  _disconnectAllAndReplaceAudioContext(newAudioContext) {
    // To be safe, make sure the clip is paused when calling this
    // TODO: do we need to maintain more thing
    this._gain.disconnect();
    this.context = newAudioContext;
    this._chunks.forEach((chunk) => {
      chunk.context = newAudioContext;
    });
    this._gain = newAudioContext.createGain();
    this._gain.gain.value = this.fadeTarget;
  }

  dispose() {
    if (this.playing) this.pause();

    if (this._loadStarted) {
      this.controller.abort();
      this._loadStarted = false;
    }

    this._currentTime = 0;
    this.loaded = new OpenPromise();
    this.canPlayThough = new OpenPromise();
    this._chunks = [];

    this.dispatchEvent(new DisposeEvent());
  }

  play() {
    const finishedPlaying = new Promise((fulfil, reject) => {
      this.once('ended', fulfil);

      this.once('loaderror', reject);
      this.once('playbackerror', reject);

      this.once('dispose', () => {
        if (this.ended) return;

        const err = new PhonographClipError('Clip was disposed', {
          phonographCode: 'CLIP_WAS_DISPOSED',
          url: this.url,
        });
        reject(err);
      });
    });

    if (!this.canPlayThough.resolvedValue) {
      this.buffer();
    }

    this.playing = true;
    this.ended = false;
    this.tryResumePlayback();

    return finishedPlaying;
  }

  pause() {
    if (!this.playing) {
      return this;
    }

    this.resetAudioNodes();
    this.stopFade();
    this.playing = false;
    this._actualPlaying = false;
    this.dispatchEvent(new PauseEvent());

    return this;
  }

  get currentTime() {
    if (this.playing && this._actualPlaying) {
      return (
        this._startTime + (this.context.currentTime - this._contextTimeAtStart)
      );
    }
    return this._currentTime;
  }

  set currentTime(currentTime) {
    if (this.playing) {
      this.pause();
      this._currentTime = currentTime;
      this._audioBufferCache = null;
      this.trySetupAudioBufferCache();
      this.play().catch(() => { });
    } else {
      this._currentTime = currentTime;
      this._audioBufferCache = null;
      this.trySetupAudioBufferCache();
    }
  }

  get duration() {
    let total = 0;
    for (const chunk of this._chunks) {
      if (!chunk.duration) return null;
      total += chunk.duration;
    }

    return total;
  }

  get paused() {
    return !this.playing;
  }

  get volume() {
    return this._gain.gain.value;
  }

  set volume(volume) {
    this.stopFade();
    this.fadeTarget = volume;
    this._gain.gain.value = volume;
  }

  fade(startVolume, endVolume, duration) {
    this.stopFade();
    if (!this.playing) {
      this.volume = endVolume;
      return;
    }
    const now = this.context.currentTime;
    this._gain.gain.value = startVolume;
    this._gain.gain.linearRampToValueAtTime(endVolume, now + duration);
    this.fadeTarget = endVolume;
  }

   stopFade() {
    const now = this.context.currentTime;
    this._gain.gain.cancelScheduledValues(now);
    this._gain.gain.value = this.fadeTarget;
  }

  // Attempt to setup AudioBufferCache if it is not setup
  // Should be called when new chunk is ready
   async trySetupAudioBufferCache() {
    if (this._audioBufferCache !== null) {
      return;
    }
    let lastChunk = null;
    let chunk =
      _nullishCoalesce(this._chunks[0], () => ( null));
    let time = 0;
    while (chunk !== null) {
      if (chunk.duration === null) {
        return;
      }
      const chunkEnd = time + chunk.duration;
      if (chunkEnd > this._currentTime) {
        // TODO: reuse audio buffer in old cache
        this._audioBufferCache = {
          currentChunkStartTime: time,
          currentChunk: chunk,
          currentBuffer: null,
          nextBuffer: null,
          pendingBuffer: null,
        };

        await this.decodeChunk(chunk);
        await _optionalChain([chunk, 'access', _5 => _5.next, 'optionalAccess', _6 => _6.attached]);
        await this.decodeChunk(_optionalChain([chunk, 'optionalAccess', _7 => _7.next]));

        this.decodeChunk(_nullishCoalesce(_optionalChain([chunk, 'optionalAccess', _8 => _8.next, 'optionalAccess', _9 => _9.next]), () => ( null)));

        return;
      }
      time = chunkEnd;
      lastChunk = chunk;
      chunk = lastChunk.next;
    }
    // All available Chunk visited, check if there are more chunks to be load.
    if (_optionalChain([lastChunk, 'optionalAccess', _10 => _10.decoded])) {
      this._audioBufferCache = {
        currentChunkStartTime: time,
        currentChunk: null,
        currentBuffer: null,
        nextBuffer: null,
        pendingBuffer: null,
      };
    }
  }

  // Check is there enough audio buffer to schedule current and next chunk
   audioBufferCacheHit() {
    const audioBufferCache = this._audioBufferCache;
    if (audioBufferCache === null) {
      return false;
    }
    const { currentChunk, currentBuffer, nextBuffer } = audioBufferCache;
    if (currentChunk === null) {
      return true;
    }
    if (!currentChunk.decoded) {
      return false;
    }
    if (currentBuffer === null) {
      return false;
    }
    const nextChunk = currentChunk.next;
    if (nextChunk === null) {
      return true;
    }
    if (!nextChunk.decoded) {
      return false;
    }
    if (nextBuffer === null) {
      return false;
    }
    return true;
  }

  // Advance the audioBufferCache to next chunk when current chunk is played
   advanceAudioBufferCache() {
    const { currentChunk, currentChunkStartTime, nextBuffer, pendingBuffer } =
      this._audioBufferCache;
    this._audioBufferCache = {
      currentChunkStartTime: currentChunkStartTime + currentChunk.duration,
      currentChunk: currentChunk.next,
      currentBuffer: nextBuffer,
      nextBuffer: pendingBuffer,
      pendingBuffer: null,
    };
    this.decodeChunk(_nullishCoalesce(_optionalChain([currentChunk, 'optionalAccess', _11 => _11.next, 'optionalAccess', _12 => _12.next, 'optionalAccess', _13 => _13.next]), () => ( null)));
  }

  // Start play the audioBuffer when the audioBufferCacheHit is true
   startPlay() {
    // Initialization of Start Time Variables.
    this._startTime = this._currentTime;
    this._actualPlaying = true;
    const { currentChunkStartTime, currentChunk, currentBuffer, nextBuffer } =
      this._audioBufferCache;

    // Recording the Current Context Time.
    this._contextTimeAtStart = this.context.currentTime;
    // Playback of the Current Audio Chunk.
    if (currentChunk !== null) {
      //  Calculates the time at which the current audio source should stop
      // playing and potentially when the next audio source should start.
      this._pendingSourceStart =
        this._contextTimeAtStart +
        (currentChunk.duration - (this._startTime - currentChunkStartTime));

      // Setup and Scheduling of the Current Audio Source
      this._currentSource = this.context.createBufferSource();
      this._currentSource.buffer = currentBuffer;
      this._currentGain = this.context.createGain();
      this._currentGain.connect(this._gain);
      this._currentGain.gain.setValueAtTime(
        0,
        this._pendingSourceStart + OVERLAP
      );
      this._currentSource.connect(this._currentGain);
      // Starts the playback of the current buffer at the computed start time.
      this._currentSource.start(
        this._contextTimeAtStart,
        this._startTime - currentChunkStartTime
      );
      // Stops the playback after the duration of the current chunk, plus an
      // overlap period.
      this._currentSource.stop(this._pendingSourceStart + OVERLAP * 2);
      this._currentSource.addEventListener('ended', this.onCurrentSourceEnd);
      // Setup and Scheduling of the Next Audio Source (if applicable)
      if (currentChunk.next !== null) {
        // If there is a next chunk to play (currentChunk.next), the method
        // repeats a similar process to set up the next audio source and gain
        // node.
        const pendingStart =
          this._pendingSourceStart + currentChunk.next.duration;
        this._nextSource = this.context.createBufferSource();
        this._nextSource.buffer = nextBuffer;
        this._nextGain = this.context.createGain();
        this._nextGain.connect(this._gain);
        this._nextGain.gain.setValueAtTime(0, this._pendingSourceStart);
        this._nextGain.gain.setValueAtTime(
          1,
          this._pendingSourceStart + OVERLAP
        );
        this._nextSource.connect(this._nextGain);
        this._nextSource.start(this._pendingSourceStart);
        // Schedules the volume to fade in at the end of the current chunk and
        // fade out at the end of the next chunk, creating a crossfade effect.
        this._nextGain.gain.setValueAtTime(0, pendingStart + OVERLAP);
        this._nextSource.stop(pendingStart + OVERLAP * 2);
        this._pendingSourceStart = pendingStart;
      }
    } else {
      this.pause().currentTime = 0;
      // TODO: schedule playing of first chunk instead of do this
      if (this.loop) {
        // If looping is enabled (this.loop), playback is restarted.
        this.play();
      } else {
        // If looping is not enabled, sets the ended flag to true and dispatches
        // an EndedEvent to signal the end of playback.
        this.ended = true;
        this.dispatchEvent(new EndedEvent());
      }
    }
  }

  // Advance audio nodes to next chunk when current chunk is played
  // and the audioBufferCacheHit is true
  // should be called after advanceAudioBufferCache
   advanceAudioNodes() {
    _optionalChain([this, 'access', _14 => _14._currentSource, 'optionalAccess', _15 => _15.stop, 'call', _16 => _16()]);
    _optionalChain([this, 'access', _17 => _17._currentSource, 'optionalAccess', _18 => _18.disconnect, 'call', _19 => _19()]);
    _optionalChain([this, 'access', _20 => _20._currentGain, 'optionalAccess', _21 => _21.disconnect, 'call', _22 => _22()]);
    this._currentGain = this._nextGain;
    this._currentSource = this._nextSource;
    _optionalChain([this, 'access', _23 => _23._currentSource, 'optionalAccess', _24 => _24.addEventListener, 'call', _25 => _25('ended', this.onCurrentSourceEnd)]);
    const { currentChunk, nextBuffer } = this._audioBufferCache;
    if ((_nullishCoalesce(_optionalChain([currentChunk, 'optionalAccess', _26 => _26.next]), () => ( null))) !== null) {
      const pendingStart =
        this._pendingSourceStart + currentChunk.next.duration;
      this._nextSource = this.context.createBufferSource();
      this._nextSource.buffer = nextBuffer;
      this._nextGain = this.context.createGain();
      this._nextGain.connect(this._gain);
      this._nextGain.gain.setValueAtTime(0, this._pendingSourceStart);
      this._nextGain.gain.setValueAtTime(1, this._pendingSourceStart + OVERLAP);
      this._nextSource.connect(this._nextGain);
      this._nextSource.start(this._pendingSourceStart);
      this._nextGain.gain.setValueAtTime(0, pendingStart + OVERLAP);
      this._nextSource.stop(pendingStart + OVERLAP * 2);
      this._pendingSourceStart = pendingStart;
    } else {
      this._nextGain = null;
      this._nextSource = null;
    }
    if (currentChunk === null) {
      this.pause().currentTime = 0;
      // TODO: schedule playing of first chunk instead of do this
      if (this.loop) {
        this.play();
      } else {
        this.ended = true;
        this.dispatchEvent(new EndedEvent());
      }
    }
  }

  // Reset audioNodes when stuck or paused
   resetAudioNodes() {
    if (this._currentSource) {
      this._currentSource.stop();
      this._currentSource.disconnect();
      this._currentSource = null;
    }
    if (this._nextSource) {
      this._nextSource.stop();
      this._nextSource.disconnect();
      this._nextSource = null;
    }
    if (this._currentGain) {
      this._currentGain.disconnect();
      this._currentGain = null;
    }
    if (this._nextGain) {
      this._nextGain.disconnect();
      this._nextSource = null;
    }
    if (!this.playing || !this._actualPlaying) {
      return;
    }
    this._currentTime =
      this._startTime + (this.context.currentTime - this._contextTimeAtStart);
    this._audioBufferCache = null;
    this.trySetupAudioBufferCache();
  }

  // Advance to next Chunk if playback of current source ends
   __init24() {this.onCurrentSourceEnd = (event) => {
    if (event.target !== this._currentSource) {
      return;
    }
    if (!this.playing || !this._actualPlaying) {
      return;
    }
    this.advanceAudioBufferCache();
    if (this.audioBufferCacheHit()) {
      this.advanceAudioNodes();
    } else {
      this.resetAudioNodes();
      this._actualPlaying = false;
    }
  };}

  // Put audio buffer into AudioBufferCache when it is decoded
   onBufferDecoded(
    chunk,
    buffer
  ) {
    const audioBufferCache = this._audioBufferCache;
    if (audioBufferCache === null) {
      return;
    }
    if (audioBufferCache.currentChunk === chunk) {
      if (audioBufferCache.currentBuffer === null) {
        audioBufferCache.currentBuffer = buffer;
      }
    } else if (_optionalChain([audioBufferCache, 'access', _27 => _27.currentChunk, 'optionalAccess', _28 => _28.next]) === chunk) {
      if (audioBufferCache.nextBuffer === null) {
        audioBufferCache.nextBuffer = buffer;
      }
    } else if (_optionalChain([audioBufferCache, 'access', _29 => _29.currentChunk, 'optionalAccess', _30 => _30.next, 'optionalAccess', _31 => _31.next]) === chunk) {
      if (audioBufferCache.pendingBuffer === null) {
        audioBufferCache.pendingBuffer = buffer;
      }
    }
    this.tryResumePlayback();
  }

  // Start chunk decode
   async decodeChunk(chunk) {
    if (chunk === null) {
      return;
    }

    await chunk.decoded;

    try {
      const buffer = await chunk.createBuffer();
      this.onBufferDecoded(chunk, buffer);
    } catch (error) {
      this.dispatchEvent(new PlaybackErrorEvent(error));
    }
  }

  // Attempt to resume playback when not actual playing
   tryResumePlayback() {
    if (this._actualPlaying || !this.playing) {
      return;
    }
    if (this._audioBufferCache === null) {
      return;
    }
    if (this.audioBufferCacheHit()) {
      this.startPlay();
    }
  }
}

export { Clip, Mp3DeMuxAdapter };
//# sourceMappingURL=module.js.map
